import React from 'react';
import DateTime from './DateTime';

const Week = (props) => {
    const {week} = props;
    const parts = week.split('-W');
    const weekNumber = parts[1];

    return <span>
        Week {weekNumber} <span className="text-muted">(w/c <DateTime {...props} />)</span>
    </span>
}

export default Week;
